(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["combined-variant-groups"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', (event) => {
    const picker = event.target.closest('variant-picker');
    const note = picker?.querySelector('[data-combined-note]');
    if (!note) return;
    const value = event.detail.variant?.options?.[0]?.toLowerCase() || '';
    const group = value.includes('(decant)') ? 'decant' : value.includes('(tester)') ? 'tester' : 'bottle';
    note.textContent = note.dataset[group + 'Note'];
  });
  } catch(e) { console.error(e); }
})();

})();
